import { ClarityType } from '../clarityValue';
import { isClarityName } from '../../utils';
function tupleCV(data) {
    for (const key in data) {
        if (!isClarityName(key)) {
            throw new Error(`"${key}" is not a valid Clarity name`);
        }
    }
    return { type: ClarityType.Tuple, data };
}
export { tupleCV };
//# sourceMappingURL=tupleCV.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/dist/esm/clarity/types/tupleCV.js
// module id = null
// module chunks = 